import React, { useEffect, useState } from 'react'
import { updateLoader } from '../../../actions/search-actions'
import store from '../../../store'
import Alert from '../../common/alert'
import AlertNew from '../../common/alertNew'
import { apiUrl } from '../../common/constants'
import GInput from '../../common/input/ginput'
import OtpForm from '../../common/cancelRequestForm';

import { countdown, getparamsString, GetRequest, PostRequest, stopTimer } from '../../common/helper'
import AccountLoader from '../accountLoader'
import { AADHAR_CARD, ADDRESS, CITY, COUNTRY_CODE, DAY, EMAIL, FEMALE, GENDER, ID_CARD, ID_NUM, IND, MALE, MOBILE_NUMBER, MONTH, NAME, NATION, OTHER, PAN_CARD, POST_CODE, STATE, UPDATE_PROFILE, YEAR, ENTER_OTP, VERIFY, RESEND_OTP_IN, RESEND_OTP_NOW, ENTER_VALID_OTP, t } from '../../../translations/ManageAccount/EditProfile'
import { LOCKOTP_MSG, tCommon } from '../../../translations/Common';
import { ExIcon } from '../../pnrEnquiry/common/svg';
import { renderImg } from '../../common/icons/img';

const EditProfile = ({ setTabs }) => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const Months = [
    { id: '01', name: "January" },
    { id: "02", name: "February" },
    { id: "03", name: "March" },
    { id: "04", name: "April" },
    { id: "05", name: "May" },
    { id: "06", name: "June" },
    { id: "07", name: "July" },
    { id: "08", name: "August" },
    { id: "09", name: "September" },
    { id: "10", name: "October" },
    { id: "11", name: "November" },
    { id: "12", name: "December" }
  ];

  const currentMonth = currentDate.getMonth() + 1;
  const currentDay = currentDate.getDate();

  const [name, setName] = useState("")
  const [errorMsg, setErrorMsg] = useState("");
  const [successmsg, setSuccessMsg] = useState("");
  const [mobile, setMobile] = useState("")
  const [address, setAddress] = useState("")
  const [city, setCity] = useState("")
  const [postal, setPostal] = useState("")
  const [idNumber, setIdNumber] = useState("")
  const [GSTIN, setGSTIN] = useState("")
  const [email, setEmail] = useState("")
  const [selectedGender, setSelectedGender] = useState("M");
  const [day, setDay] = useState(currentDay);
  const [year, setYear] = useState(currentYear);
  const [idCard, setIdCard] = useState("Aaadhar Card")
  const [selState, setSelState] = useState("Karnataka")
  const [countryCode, setCountryCode] = useState("+91")
  const [month, setMonth] = useState(Months[currentMonth - 1].id);

  const [profileData, setProfileData] = useState({});
  const [loader, setLoader] = useState(false);
  const [mobEnable,setMobEnable] = useState(false);
  const [otpRequest,setOtpRequest] = useState(false);
  const [password, setPassword] = useState("");
   const [user, setUser] = useState({ mobile: '', otp: '' });
  const [otpSent, setOtpSent] = useState(false);
  const [resend, setResend] = useState("");
  const [togglePassword, setTogglePassword] = useState(false);
  const [invalidOTP, setInvalidOTP] = useState(false);
  const [isLockedOTP, setIsLockedOTP] = useState(false);
  
  const years = [];
  for (let i = currentYear; i >= currentYear - 100; i--) {
    years.push(i);
  }

  const indian_states = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Delhi",
  ]
  // Generating an array of days (1 to 31)
  const dates = Array.from({ length: 31 }, (_, i) => i + 1);
  useEffect(() => {
    // getData()
    if (window.customerProfile && window.customerProfile.EmailID) {
      const { EmailID, } =
        window.customerProfile;
      // setProfileData({ ...profileData, userName, name: CustomerName });
      getUserProgile(EmailID);
    } else {
      setErrorMsg("Please Login");
    }
  }, [])
  const getUserProgile = (EmailID) => {
    let url = apiUrl.getUserDetails;
    const data = { userName: EmailID };
    // url = url + "?" + getparamsString(data);
    store.dispatch(updateLoader(true));
    setLoader(true);
    GetRequest(url)
      .then((res) => {
        store.dispatch(updateLoader(false));
        setLoader(false)
        if (res.Success === true) {
          const obj = res.data;
          setName(obj.name.toString() || "")
          setMobile(obj.mobileNo.toString() || "")
          setCity(obj.city || "")
          setSelState(obj.state || "Karnataka")
          setEmail(obj.userName || "")
          setIdNumber(obj.idCardNo.toString());
          setIdCard(obj.idCardName.toString());
          setCountryCode(obj.countryCode || "+91")
          setSelectedGender(obj.gender || "M")
          setAddress(obj.address || "")
          setPostal(obj.pinCode || "")
          if (!obj.dob) {
            obj.dob = `${year}-${month}-${day}`;
          }
          const [year, month, day] = obj.dob && obj.dob.split("-");
          setDay(day)
          setYear(year)
          setMonth(month)
          setProfileData(res.data);
        }
      })
      .catch((err) => { store.dispatch(updateLoader(false)); setLoader(false) });
  };
  const validation = () => {
    if (name === "") {
      setErrorMsg("Enter Name")
      return false
    } else if (mobile === "") {
      setErrorMsg("Enter Mobile Number")
      return false
    } else if (city === "") {
      //setErrorMsg("Enter Mobile Number")
      //return false
    } else if (email === "") {
      setErrorMsg("Enter Email Id")
      return false
    } else if (idNumber === "") {
      //setErrorMsg("Enter Mobile Number")
      //return false
    }
    return true
  }

  const updateProfile = () => {
    if (validation()) {
      const data = profileData;
      data.userName = email || ""
      data.mobileNo = mobile || ""
      data.name = name || ""
      data.dob = `${year}-${month}-${day.toString().length !== 2 ? "0" + day : day.toString()}`
      data.gender = selectedGender
      data.address = address
      data.city = city
      data.state = selState
      data.idCardNo = idNumber
      data.idCardName = idCard
      data.countryCode = countryCode
      data.pinCode = postal
      data.csrf_token = window.csrf_token
      store.dispatch(updateLoader(true))
      setLoader(true);
      PostRequest(apiUrl.editUserDetails, data)
        .then((res) => {
          if(res.Success){
             store.dispatch(updateLoader(false))
             setLoader(false);
             setSuccessMsg("You profile has been successfully updated");
          }else{
            store.dispatch(updateLoader(false))
            setLoader(false);
            setErrorMsg(res.ErrorMessage);
          }
        })
        .catch((err) => { store.dispatch(updateLoader(false)); setLoader(false); });
    }

  };

  const updateMobile = () =>{
     if(mobile && String(mobile).length === 10){
        const data = {}
        data.mobileNo = mobile;
        store.dispatch(updateLoader(true))
        setLoader(true);
        PostRequest(apiUrl.editUserMobile, data)
          .then((res) => {
            store.dispatch(updateLoader(false));
            setLoader(false);
            setOtpRequest(false);
            setSuccessMsg("You profile mobile no has been successfully updated");
          })
          .catch((err) => { store.dispatch(updateLoader(false)); setLoader(false); });
      }
  }

  const generateOtp = () => {
        if (mobile && String(mobile).length === 10 && mobile > 6000000000) {
            setLoader(true);
            const url = `${apiUrl.generateOTPV2}?mobileNo=${mobile}&type=editProfile`;
            GetRequest(url).then(res => {
                if (res.Success === true) {
                    countdown('mobileClock', 3, 0, setResend);
                    setOtpRequest(true);
                    setOtpSent(true);
                    setResend("disable");
                }else{
                    setErrorMsg(res.ErrorMessage);
                }
                setLoader(false);
            })

        } else {
            setErrorMsg('Please enter valid Mobile no');
        }
        user.otp = '';
        setPassword("");
        setUser({ ...user });
    }

    const verify = () => {
        setInvalidOTP(false);
        setIsLockedOTP(false);
        setLoader(true);

        const url = `${apiUrl.validateOTPV2}?OTP=${password}&mobileNo=${mobile}`;
        GetRequest(url).then(result => {
            setLoader(false);
            if (result.Success) {
                stopTimer();
                // getStatusDetails(pnr);
                updateMobile();
            } else {
              result?.IsLocked ? setIsLockedOTP(true) : setInvalidOTP(true);
            }
        }).catch((err) => {
            console.log("err", err);
            setLoader(false);
        });
    }

    const handelCloseOtpForm = (val) => {
        stopTimer();
        setOtpRequest(val);
    }

  return (
    <React.Fragment>
      {loader && <AccountLoader />}
      <div className="EditProfile-wrapper">
        <div className="editProfile-form">
          <div className="row" style={{position:'relative'}}>
            <GInput
              value={name || ""}
              onChange={(e) => setName(e)}
              validation="name"
              errMsg="Valid Name Required"
              label={t(NAME)}
              key={"name"}
            />
            <GInput
              value={mobile || ""}
              onChange={(e) => setMobile(e)}
              validation="mobile"
              errMsg="Valid Mobile Number Required"
              label={t(MOBILE_NUMBER)}
              key={"mobile"}
              disabled={mobEnable ? false : true}
            />
            {
              mobEnable ?
               <div className='update--btn' onClick = {()=>generateOtp()}>SAVE</div>
               :
              <div className='update--btn' onClick = {()=>setMobEnable(true)}>UPDATE</div>
               
            }
           
          </div>
          <div className="row">
            <div className="dropDown">
              <label for="gender">{t(GENDER)}</label>
              <select name="gender" id="gender" value={selectedGender} onChange={(e) => setSelectedGender(e.target.value)}>
                <option value="M">{t(MALE)}</option>
                <option value="F">{t(FEMALE)}</option>
                <option value="O">{t(OTHER)}</option>
              </select>
            </div>
            <div className="dateOf-birth">
              <div className="dropDown">
                <label for="Year">{t(YEAR)}</label>
                <select name="Year" id="Year" value={year} onChange={(e) => setYear(e.target.value)}>
                  {
                    years.map((val) => <option value={val}>{val}</option>)
                  }
                </select>
              </div>
              <div className="dropDown">
                <label for="Month">{t(MONTH)}</label>
                <select name="Month" id="Month" value={month} onChange={(e) => setMonth(e.target.value)}>
                  {
                    Months.map((val) => <option value={val.id} disabled={Number(currentYear) === Number(year) && Number(val.id) > Number(currentMonth)}>{val.name}</option>)
                  }
                </select>
              </div>
              <div className="dropDown">
                <label for="Day">{t(DAY)}</label>
                <select name="Day" id="Day" value={day} onChange={(e) => setDay(e.target.value)}>
                  {
                    dates.map((val, i) =>
                      <option key={val} value={val} disabled={(Number(val) > Number(currentDay)) && (Number(currentYear) === Number(year)) && (Number(month) + 1 > Number(currentMonth))}>{val}</option>
                    )
                  }
                </select>
              </div>
            </div>
            {/* */}
          </div>
          <div className="row">
            <div className="dropDown">
              <label for="Nationality">{t(NATION)}</label>
              <select name="Nationality" id="Nationality" >
                <option value="Indian">{t(IND)}</option>
              </select>
            </div>
            <GInput
              value={address || ""}
              onChange={(e) => setAddress(e)}
              label={t(ADDRESS)}
              key={"address"}
            />
          </div>
          <div className="row">
            <GInput
              value={city || ""}
              onChange={(e) => setCity(e)}
              validation="name"
              errMsg="Valid City Required"
              label={t(CITY)}
              key={"city"}
            />
            <div className="dropDown">
              <label for="CountryCode" value={countryCode} onChange={(e) => setCountryCode(e.target.value)}>{t(COUNTRY_CODE)}</label>
              <select name="CountryCode" id="CountryCode" >
                <option value="+91">+91</option>
              </select>
            </div>
          </div>
          <div className="row">
            <div className="dropDown">
              <label for="state">{t(STATE)}</label>
              <select name="state" id="state" value={selState} onChange={(e) => setSelState(e.target.value)}>
                {
                  indian_states.map((val) => <option value={val}>{val}</option>)
                }

              </select>
            </div>

            <GInput
              value={postal || ""}
              onChange={(e) => setPostal(e)}
              label={t(POST_CODE)}
              validation={"postal"}
              key={"postal"}
              max={6}
            />
          </div>
          <div className="row">
            <div className="dropDown">
              <label for="idCard">{t(ID_CARD)}</label>
              <select name="idCard" id="idCard" value={idCard} onChange={(e) => setIdCard(e.target.value)}>
                <option value="Aadhar Card">{t(AADHAR_CARD)}</option>
                <option value="Pan Card">{t(PAN_CARD)}</option>
              </select>
            </div>
            <GInput
              value={idNumber || ""}
              onChange={(e) => setIdNumber(e)}
              validation="idCardNo2"
              errMsg="Valid Id Card Number Required"
              label={t(ID_NUM)}
              key={"IDNumber"}
            />
          </div>
          <div className="row">

            <GInput
              value={GSTIN || ""}
              onChange={(e) => setGSTIN(e)}
              label={t(GSTIN)}
              key={"GSTIN"}
            />
            <GInput
              value={email || ""}
              onChange={(e) => setEmail(e)}
              validation="email"
              errMsg="Valid Eamil  Required"
              label={t(EMAIL)}
              key={"Email"}
              disabled={true}
            />
          </div>
          <div className="updateProf-button">
            <button className='' onClick={() => updateProfile()}>{t(UPDATE_PROFILE)}</button>
          </div>
        </div>

      </div>
      {errorMsg && (
        <Alert
          msg={errorMsg}
          error={true}
          close={() => setErrorMsg("")}
        />
      )}
      {successmsg && (
        <AlertNew
          msg={successmsg}
          buttonText=""
          success={true}
          close={() => {
            setSuccessMsg("");
            window.location.reload();
            setTabs(4)
            // window.location.href = "/account";
          }}
        />
      )}

      {
        otpRequest &&

        <OtpForm

            msg={
                < div
                    className="booking--inquiry"
                    style={{ justifyContent: "center" }}
                >
                    <GInput
                        type={togglePassword ? "text" : "password"}
                        value={password}
                        onChange={(e) => setPassword(e)}
                        label={t(ENTER_OTP)}
                        key={"password"}
                        icon2={renderImg("view-icon")}
                        onIconClick={() =>
                            setTogglePassword(!togglePassword)
                        }
                        autoFocus={true}
                        validation="password"
                        max={6}
                    />
                    <div className="cancel--request--btn" onClick={verify}>{t(VERIFY)}</div>
                    <div className="bookingStatus-message">
                        <div className="message" style={{ display: 'flex', paddingTop: '10px', justifyContent: 'center' }}>
                            {
                                resend === "" ? "" :
                                    resend === "Resend" ? <span style={{ color: 'var(--ksrtcThColor1)', cursor: 'pointer' }} onClick={generateOtp}>{t(RESEND_OTP_NOW)}</span> :
                                        <><span style={{ marginRight: '8px', marginTop: '-2px' }}><ExIcon /></span><span> {t(RESEND_OTP_IN)} </span> <span id="mobileClock" style={{ color: "red", marginLeft: '4px' }}></span></>
                            }
                        </div>
                    </div>
                    {
                        invalidOTP && (
                            <div className="bookingStatus-otp-message">
                                <div className="otp-message">
                                    <span>{t(ENTER_VALID_OTP)}</span>
                                </div>
                            </div>
                        )
                    }
                    {
                      isLockedOTP && (
                          <div className="bookingStatus-otp-message">
                              <div className="otp-message">
                                  <span>{tCommon(LOCKOTP_MSG)}</span>
                              </div>
                          </div>
                      )
                    }
                </div>
            }

            onClick={handelCloseOtpForm}    
        />

    }

    </React.Fragment>
  )
}

export default EditProfile